import React from "react";

const CustomModal = ({
  open,
  message,
  yesText = "Yes",
  noText = "No",
  onYes,
  onNo,
}) => {
  if (!open) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <p style={styles.message}>{message}</p>
        <div style={styles.buttonRow}>
          {yesText !== "NA" && (
            <button style={styles.button} onClick={onYes}>
              {yesText}
            </button>
          )}

          <button style={styles.button} onClick={onNo}>
            {noText}
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },
  modal: {
    background: "#fff",
    padding: "2rem",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    minWidth: "300px",
    maxWidth: "90vw",
    textAlign: "center",
  },
  message: {
    marginBottom: "2rem",
  },
  buttonRow: {
    display: "flex",
    justifyContent: "center",
    gap: "2rem",
  },
  button: {
    padding: "0.5rem 2rem",
    fontSize: "1rem",
    borderRadius: "6px",
    border: "none",
    background: "#EC6466",
    color: "white",
    cursor: "pointer",
  },
};

export default CustomModal;
